import React, { useEffect, useState } from "react";
import SideBarBack from "../../components/SidebarBack";
import { useDispatch, useSelector } from "react-redux";
import { setDrawerActiveMenu } from "../../store/features/webUtilitiesSlice";
import ChatBot from "react-simple-chatbot";
import { ThemeProvider } from "styled-components";
import secureLocalStorage from "react-secure-storage";
import axios from "axios";
import { ASKNEXPERT_ENDPOINT } from "../../config/ApisCollection";

export default function Chatbot() {
  const { profileDetails } = useSelector((state) => state.webUtilities);
  const accessToken = secureLocalStorage.getItem("accessToken");

  // Chat bot data
  const [dynamicData, set_Dynamic_data] = useState([]);
  const steps = [
    {
      id: "0",
      message: "Hey there! How can I assist you today?",
      trigger: "1",
    },
    {
      id: "1",
      user: true,
      trigger: "2",
    },
    {
      id: "2",
      message: ({ previousValue }) => findBestMatch(previousValue),
      trigger: "3",
    },
    {
      id: "3",
      message: "Do you have any other questions?",
      trigger: "4",
    },
    {
      id: "4",
      options: [
        {
          value: "yes",
          label: "Yes",
          trigger: "1",
        }, // Go back to question step
        {
          value: "no",
          label: "No",
          end: true,
        }, // End conversation
      ],
    },
  ];

  // Function to find the best match for the user input
  const findBestMatch = (input) => {
    const lowerCaseInput = input.toLowerCase();
    const bestMatch = dynamicData.find((item) =>
      item.question.toLowerCase().includes(lowerCaseInput)
    );
    return bestMatch ? bestMatch.answer : "Sorry, I didn't understand that.";
  };

  // Creating our own theme
  const theme = {
    background: "#FFEDE0",
    headerBgColor: "#FF9950",
    headerFontSize: "20px",
    botBubbleColor: "#18192B",
    headerFontColor: "white",
    botFontColor: "white",
    userBubbleColor: "#FF5050",
    userFontColor: "white",
  };

  // Set some properties of the bot
  const config = {
    botAvatar: "/favicon.webp",
    userAvatar: profileDetails.image,
    floating: false,
  };
  // chatbot data

  const GetQuestions = async () => {
    const post_header = {
      headers: {
        Authorization: `Bearer ${accessToken}`,
        "Content-Type": "application/json",
      },
    };
    try {
      await axios
        .post(`${ASKNEXPERT_ENDPOINT}`, {}, post_header)
        .then((response) => {
          set_Dynamic_data(response.data.qa);
          // console.log(response.data.qa);
        });
    } catch (error) {}
  };

  const dispatch = useDispatch();

  const handleCloseDrawer = async () => {
    await dispatch(setDrawerActiveMenu(1));
  };

  useEffect(() => {
    GetQuestions();
  }, []);
  return (
    <div className="w-full h-full">
      <div className="w-full flex mb-2">
        <SideBarBack handleCloseDrawer={handleCloseDrawer} />
      </div>
      <div className="bodyly spwok pb-8 gap-6 flex flex-col justify-between">
        <div className="profileinfo px-8">
          {dynamicData.length > 0 ? (
            <ThemeProvider theme={theme}>
              <ChatBot
                // This appears as the header
                // text for the chat bot
                headerTitle="Fastbetter"
                steps={steps}
                {...config}
              />
            </ThemeProvider>
          ) : (
            <></>
          )}
        </div>
      </div>
    </div>
  );
}
